"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarView = void 0;
const View_1 = require("../core/render/View");
const viewModelCollection_1 = require("../viewModelCollection");
class NavBarView extends View_1.View {
    constructor() {
        super();
        this.dataContext = viewModelCollection_1.getNavigationBarViewModel();
        this.navList = document.createElement("ul");
        this.renderBody = document.createElement("heading");
        this.onRender = () => {
            let navBar = document.createElement("nav");
            navBar.appendChild(this.navList);
            this.renderBody.appendChild(navBar);
        };
    }
    addNavLink(linkName) {
        let listItem = document.createElement("li");
        let anchor = document.createElement("a");
        anchor.text = linkName;
        anchor.addEventListener("click", (event) => this.navItemClicked(event.target.text));
        listItem.appendChild(anchor);
        this.navList.appendChild(listItem);
    }
    shouldRender() {
        return true;
    }
}
exports.NavBarView = NavBarView;
//# sourceMappingURL=NavBarView.js.map